module.exports = __webpack_public_path__ + "img/system-integration.025ad675.svg";